module.exports = __webpack_public_path__ + "media/img/frontend_application/vca-award-badge-b7d44ad8ad5789a68ad1cd3a56e46c87.gif";